const originalDefine = customElements.define;
customElements.define = function (name, constructor, options) {
  if (!customElements.get(name)) {
    originalDefine.call(customElements, name, constructor, options);
  }
};

import "../../node_modules/img-comparison-slider/dist/index.js";
import "../../node_modules/img-comparison-slider/dist/styles.css";
